/*
*获取数组的id集合
*/
function GetArrayIds(arry){
    let ids = [];
    arry.map((item) => {
        ids.push(item.id)
    });
    return ids
}

export default GetArrayIds